import StatusIconSmall from '../../templates/loading/StatusIconSmall'

import * as con from "../../GlobalConstants"
import { RefTransactionsHook } from '../hooks/TransactionsHooks';


function TransactionExtractionLoadingIcons() {

  // ----------------- 
    const transactionStatus = RefTransactionsHook(con.TRANSACTIONS_LOADED);

  return (
    <div>
    <h4>Extrayendo las transacciones de la base de datos.</h4>
    <div className="mediumParameterBox">
      <div className="mediumParameterBox">
        <StatusIconSmall
          status={transactionStatus?.[con.EXPOSURES]}
          title="Exposiciones"
        />

        <StatusIconSmall
          status={transactionStatus?.[con.COVERAGES_SPOT]}
          title="Coberturas SPOT"
        />

        <StatusIconSmall
          status={transactionStatus?.[con.COVERAGES_OPTION]}
          title="Coberturas Opciones"
        />

        <StatusIconSmall
          status={transactionStatus?.[con.COVERAGES_FWD]}
          title="Coberturas FWD"
        />

        <StatusIconSmall
          status={transactionStatus?.[con.ACCOUNTS]}
          title="Cuentas"
        />
      </div>
    </div>
  </div>
  )
}

export default TransactionExtractionLoadingIcons